// extracted by mini-css-extract-plugin
export default {"miniCartTotal":"MiniCartTotal_miniCartTotal__n0nsm","total":"MiniCartTotal_total__lPt3c","amount":"MiniCartTotal_amount__0Pg0k"};